import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // ACM check-auth call uses cookie-based session
    if (req.url === environment.authCheckUrl) {
      return next.handle(req.clone({ withCredentials: true }));
    }

    // Local backend calls — attach the stored UM token as the Bearer token (the
    // backend verifies it with UM's check-auth), as ACM's interceptor does. Scoped
    // to our backend so the token never goes to third-party hosts. Include
    // withCredentials so the UM session cookie is forwarded to the nginx gateway that sits in front of the /planning route on qastg/prod.
    if (req.url.startsWith(environment.apiBaseUrl)) {
      const token = AuthService.getToken();
      if (token) {
        return next.handle(req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }));
      }
      // No token stored yet (pre-auth requests) — still send credentials
      // so the gateway can validate the UM session cookie.
      return next.handle(req.clone({ withCredentials: true }));
    }

    return next.handle(req);
  }
}
